import { render } from "./05_Access.vue?vue&type=template&id=2518cdab&scoped=true"
import script from "./05_Access.vue?vue&type=script&lang=js"
export * from "./05_Access.vue?vue&type=script&lang=js"

import "./05_Access.vue?vue&type=style&index=0&id=2518cdab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2518cdab"]])

export default __exports__